module.exports = __webpack_public_path__ + "media/images/logo-82f1a1c4361e6cade1d2938265018210.png";